export class SignUpRequest {
  public KrugoId: string = '';
  public password: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public phoneNumber: string = '';
  public confirmationCode: string = '';
}
